<template>
  <div class="py-6 px-8">
    <h-header />

    <DivergenceListFilters />

    <v-card outlined>
      <v-data-table
        @dblclick:row="reviewRow"
        :loading-text="$t('divergence.table.loading')"
        :no-data-text="$t('divergence.table.noData')"
        :items="divergences"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :headers="headers"
        item-key="row_key"
        mobile-breakpoint="20"
        class="clickable"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.appointment_code`]="{ item }">
          <span class="font-weight-bold">{{ item.appointment_code }}</span>
        </template>

        <template v-slot:[`item.types`]="{ item }">
          <v-chip v-for="type in item.types" :key="type" class="caption mr-1" small>
            {{ $t(`divergence.type.${type}`) }}
          </v-chip>
        </template>

        <template v-slot:[`item.realty_code`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div class="my-2 d-flex align-start gap-1 align-center" v-on="on">
                <div>
                  <v-chip class="caption text-truncate mw-100" small>
                    {{ item.realty_code }}
                  </v-chip>
                </div>
                <p class="mb-0 text-ellipsis text-truncate mw-300">
                  {{ item.realty_address }}
                </p>
                <v-chip v-if="item.realty_count > 1" class="caption ml-1" x-small>
                  +{{ item.realty_count - 1 }}
                </v-chip>
              </div>
            </template>
            <span>
              <span class="font-weight-bold">{{ item.realty_code }}</span>
              <span> - {{ item.realty_address }} </span>
            </span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.host_name`]="{ item }">
          <v-tooltip v-if="item.reimbursement" bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ item.host_name }}
                <v-icon class="ml-1" x-small>mdi-information-outline</v-icon>
              </span>
            </template>
            <span>{{ $t('divergence.table.requestedByHint') }}</span>
          </v-tooltip>
          <span v-else>{{ item.host_name }}</span>
        </template>

        <template v-slot:[`item.real_estate_name`]="{ item }">
          <span class="text-truncate">{{ item.real_estate_name }}</span>
        </template>

        <template v-slot:[`item.oldest_created_at`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption" v-on="on">{{ formatDate(item.oldest_created_at) }}</span>
            </template>
            <span>{{ queueHint(item) }}</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.statuses`]="{ item }">
          <v-chip :class="statusColor(rowStatus(item))" small>
            {{ $t(`divergence.status.${rowStatus(item)}`) }}
          </v-chip>
        </template>

        <template v-slot:[`item.item_count`]="{ item }">
          <span class="font-weight-medium">{{ item.item_count }}</span>
        </template>

        <template v-slot:[`item.estimated_host_delta_sum`]="{ item }">
          <span class="caption">{{ rowAmount(item) == null ? '—' : formatMoney(rowAmount(item)) }}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-end">
            <v-btn @click="review(item)" icon small>
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <ModalReviewDivergence ref="modalReviewDivergence" />

    <h-pagination :fetch="fetchDivergences" :requireOrderByFilter="false" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { headers } from './divergenceHeaders'
import { reimbursementAmount, rowStatus, statusColor } from './divergenceHelpers'

import DivergenceListFilters from './components/DivergenceListFilters'
import ModalReviewDivergence from './components/ModalReviewDivergence'

export default {
  name: 'DivergenceList',

  components: {
    DivergenceListFilters,
    ModalReviewDivergence,
  },

  data() {
    return {
      headers,
      formatDate: catalogDate,
      formatMoney: catalogMonetary,
    }
  },

  computed: {
    ...mapGetters(['divergences', 'isLoading', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['fetchDivergences']),

    review(request) {
      this.$refs.modalReviewDivergence.openModal(request)
    },

    reviewRow(_, { item }) {
      this.review(item)
    },

    rowStatus,
    statusColor,

    /** No ressarcimento o número é o valor da ida; no recálculo, a soma das estimativas em aberto. */
    rowAmount(item) {
      return item.reimbursement ? reimbursementAmount(item) : item.estimated_host_delta_sum
    },

    queueHint(item) {
      if (!item.has_pending_items) return this.$t('divergence.queue.finished')
      return this.$t('divergence.queue.pendingFor', { hours: item.pending_for_hours ?? 0 })
    },
  },

  mounted() {
    this.fetchDivergences()
  },
}
</script>
